/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SearchBar from "components/SearchBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { MdPrint } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "helper/ToastAdapter";
import {
  Button,
  Card,
  Col,
  Input,
  Label,
  Row,
  Spinner,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { weekAgo, today, monthAgo } from "redux/action/api";
import { formatNumber } from "redux/action/api";
import { postApi } from "redux/action/api_tbeams";
import moment from "moment";
import { getSector } from "helper";
import { getMDaType } from "helper";
import RealiseCollectionPdfWebView from "components/RealiseCollectionPdfWebView";
import NewRelisePdfWebView from "components/NewRelisePdfWebView";
import ReleaseHistoryGenericTab from "./ReleaseHistoryGenericTab";

export default function ReleasesTable(props) {
  const {
    type,
    filterBy = "Approval Initiated",
    approval_status = "approvals Reviewed",
    title = "Internal Control",
    query_type = "select_by_status",
    return_status,
    showButton = false,
    showHistoryTab = false,
  } = props;
  const navigate = useNavigate();
  const { addToast } = useToasts();

  const [isLoading, setIsLoading] = useState(true);
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [form, setForm] = useState({
    remark: "",
    reject: "",
    date_from: monthAgo,
    date_to: today,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [directors, setDirectors] = useState([]);
  const [showBulkPreview, setShowBulkPreview] = useState(false);
  const [bulkPreviewData, setBulkPreviewData] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState({
    loaded: 0,
    total: 0,
  });
  // const [final, setFinalAppr] = useState("");

  const handleChanges = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const location = useLocation();
  const isPending = location.pathname.includes("payapp");
  const [filter] = useState(type || "All");

  const getApprovalCollection = useCallback(() => {
    setIsLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type,
        filter,
        type: "release",
        approval_status: filterBy,
        date_from: form.date_from,
        date_to: form.date_to,
      },
    })
      .then((data) => {
        console.log("data", data);
        if (data.result) {
          const arr = data.result.map((item) => ({
            ...item,
            isOpen: false,
          }));
          setBudgetUtilization(arr);
        }
      })
      .catch((err) => {
        // Handle errors
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filterBy, isPending, form.date_from, form.date_to]);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection]);

  // Load directors for signature
  useEffect(() => {
    getSector({}, "select_director", setDirectors);
  }, []);

  const filteredData = budgetUtilization.filter((item) =>
    item.mda_name?.toLowerCase().includes(searchQuery?.toLowerCase()),
  );

  const getRowStyle = (row) => {
    const status = row.approval_status?.toLowerCase() || "";

    // Partial matches (includes)
    if (status.includes("returned")) {
      return { backgroundColor: "#8B0000", color: "white" };
    }

    if (status.includes("queried")) {
      return { backgroundColor: "yellow" };
    }

    // Show orange if status does NOT include any of these strings
    if (
      !status.includes("return") &&
      !status.includes("approvals reviewed") &&
      !status.includes("final internal controls") &&
      !status.includes("approval initiated") &&
      !status.includes("budget approval released") &&
      !status.includes("approval released") &&
      !status.includes("discard")
    ) {
      return { backgroundColor: "orange", };
    } else if (status.includes("budget approval released")) {
      return { backgroundColor: "#a95f05ff", color: "white" };
    }

    // Exact / fallback matches
    switch (status) {
      // case "Budget Approval Released":
      //   return { backgroundColor: "orange" };

      default:
        return { backgroundColor: "" };
    }
  };

  let styles = {
    fontSize: 15,
  };

  const bodyStyle = (item) => {
    return { fontSize: 15, ...getRowStyle(item) };
  };

  const fetchSingleRelease = async (item) => {
    try {
      const response = await postApi(`post_approval_collection`, {
        form: {
          query_type: "select_by_approval_nos",
          approval_no: item.approval_no,
        },
      });

      if (response.result && response.result.length > 0) {
        const _data = response.result[0];

        let copies = null;
        let copies1 = null;

        try {
          const ccResponse = await postApi(`post-cc?query_type=select_mda`, {
            mda_name: _data.mda_name,
          });
          if (ccResponse.results) {
            copies = ccResponse.results[0];
          }
        } catch (err) {
          console.log("Error fetching CC copies:", err);
        }

        try {
          const ccResponse1 = await postApi(`post-cc?query_type=select_mda`, {
            mda_name: _data.mda_head,
          });
          if (ccResponse1.results) {
            copies1 = ccResponse1.results[0];
          }
        } catch (err) {
          console.log("Error fetching CC copies1:", err);
        }

        let mda_sn = "";
        try {
          await new Promise((resolve) => {
            getMDaType(
              {},
              _data.mda_code,
              (d) => {
                mda_sn = d[0]?.mda_sn || "";
                resolve();
              },
              "select_sn",
            );
          });
        } catch (err) {
          console.log("Error fetching MDA type:", err);
        }

        return {
          ...response.result,
          formData: {
            ..._data,
            mda_sn,
            approved_amount: _data.amount,
            copies,
            copies1,
            mda_economic_code: _data.economic_code,
          },
          pdfData: response.result.map((i) => ({
            ...i,
            approved_amount: i.amount,
            mda_economic_code: i.economic_code,
            description: i.description_code,
          })),
        };
      }
      return null;
    } catch (err) {
      console.log(`Error fetching data for ${item.approval_no}:`, err);
      return null;
    }
  };

  const handleBulkPreview = async () => {
    if (filteredData.length === 0) {
      addToast("No releases to preview", {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }

    const total = filteredData.length;
    setLoadingProgress({ loaded: 0, total });
    setBulkPreviewData([]);
    setShowBulkPreview(true);
    setIsPrinting(true);

    const concurrency = 5;
    let index = 0;

    const processNext = async () => {
      while (index < total) {
        const current = index++;
        const item = filteredData[current];
        const release = await fetchSingleRelease(item);
        if (release) {
          setBulkPreviewData((prev) => [...prev, release]);
        }
        setLoadingProgress((prev) => ({ ...prev, loaded: prev.loaded + 1 }));
      }
    };

    const workers = Array.from({ length: concurrency }, () => processNext());
    await Promise.all(workers);

    setIsPrinting(false);
  };

  const processingPage = location.pathname?.includes("/release-collection");

  const CurrentReleasesContent = () => (
    <Card style={{ border: "none", boxShadow: "none" }}>
      {showButton && (
        <Col md={4} className="mt-4">
          <button
            className="btn btn-primary"
            style={{ marginRight: "10px", marginLeft: "10px" }}
            onClick={() => navigate("/new-realise-collection")}
          >
            Add Release Processing
          </button>
        </Col>
      )}

      <form onSubmit={(e) => e.preventDefault()}>
        <Row
          style={{
            margin: 10,
          }}
        >
          <Col md={4}>
            <Label>Search From Table</Label>
            <SearchBar
              placeholder="Search By code or description"
              filterText={searchQuery}
              onFilterTextChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </Col>

          <Col md={2}>
            <Label>Date From</Label>
            <Input
              type="date"
              value={form.date_from}
              name="date_from"
              onChange={handleChanges}
            />
          </Col>
          <Col md={2}>
            <Label>Date To</Label>
            <Input
              type="date"
              value={form.date_to}
              name="date_to"
              onChange={handleChanges}
            />
          </Col>
          {title === "Signed Approvals" && (
            <Col md={4} className="d-flex align-items-end">
              <Button
                color="success"
                size="md"
                onClick={handleBulkPreview}
                disabled={isPrinting || filteredData.length === 0}
                style={{
                  width: "100%",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {isPrinting ? (
                  <>
                    <Spinner size="sm" />
                    Loading Preview...
                  </>
                ) : (
                  <>
                    <MdPrint size="18px" />
                    Preview All ({filteredData.length})
                  </>
                )}
              </Button>
            </Col>
          )}
        </Row>
      </form>
      <div
        className="mt-4"
        style={{
          width: "100%",
          height: 400,
          overflowX: "scroll",
        }}
      >
        <Table style={{ width: "120%" }} bordered>
          <thead>
            <tr>
              <th style={styles}>Action</th>
              <th style={styles}>Collection Date</th>
              <th style={styles}>Approval Date</th>
              <th style={styles}>MDA Name</th>
              <th style={styles}>Amount</th>
              <th style={styles}>Reference No.</th>
              <th style={styles}>Approval Type</th>
            </tr>
          </thead>

          {isLoading ? (
            <Spinner color="primary" />
          ) : (
            <tbody>
              {filteredData?.map((item, idx) => (
                <tr key={idx}>
                  <td style={bodyStyle(item)}>
                    {item.approval_status === "No Budget" ? null : (
                      <Button
                        className="d-flex"
                        size="sm"
                        onClick={() => {
                          navigate(
                            `/view-release?approval_no=${item.approval_no}&approval_status=${approval_status}&return_status=${return_status}&showButton=${showButton}&type=${item.approval_status}&id=${item.id}&title=${title}`,
                          );
                        }}
                      >
                        <IoMdCheckmark size="18px" style={{ marginRight: 6 }} />
                        View
                      </Button>
                    )}
                  </td>
                  <td style={bodyStyle(item)}>{item.collection_date}</td>
                  <td style={bodyStyle(item)}>{item.approval_date}</td>
                  <td style={bodyStyle(item)}>
                    {item.total_list > 1
                      ? `${item?.project_type || item?.narration?.substring(0, 20) + "..."} for ${moment(item.collection_date).format("MMMM")} ${moment().format("YYYY")}`
                      : item.mda_name}
                  </td>
                  <td
                    style={{
                      ...bodyStyle(item),
                      textAlign: "right",
                    }}
                  >
                    {formatNumber(item.amount)}
                  </td>
                  <td style={bodyStyle(item)}>{item.approval_no}</td>
                  <td style={bodyStyle(item)}>{item.approved_by}</td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>
      </div>
    </Card>
  );

  const RenderComponent = () => {
    // If showing bulk preview, render the preview with print button
    if (showBulkPreview) {
      return (
        <div>
          {/* Header with back and print buttons */}
          <div
            className="no-print"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            <Button
              color="secondary"
              onClick={() => setShowBulkPreview(false)}
              style={{ fontWeight: 500 }}
            >
              ← Back to List
            </Button>
            <h5 style={{ margin: 0, color: "#333" }}>
              Bulk Preview - {bulkPreviewData.length} Release
              {bulkPreviewData.length !== 1 ? "s" : ""}
              {isPrinting && (
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 400,
                    marginLeft: "8px",
                    color: "#888",
                  }}
                >
                  (loading {loadingProgress.loaded} of {loadingProgress.total}
                  ...)
                </span>
              )}
            </h5>
            <Button
              color="success"
              onClick={() => window.print()}
              disabled={isPrinting || bulkPreviewData.length === 0}
              style={{
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {isPrinting ? (
                <>
                  <Spinner size="sm" /> Loading...
                </>
              ) : (
                <>
                  <MdPrint size="18px" /> Print All
                </>
              )}
            </Button>
          </div>

          {/* Render all releases */}
          <div
            id="bulk-print-container"
            style={{ backgroundColor: "#f5f5f5", padding: "20px" }}
            className="print-container"
          >
            <style>{`
              @media print {
                @page {
                  margin: 0;
                  size: A4;
                }
                body * {
                  visibility: hidden;
                }
                #bulk-print-container, #bulk-print-container * {
                  visibility: visible;
                }
                #bulk-print-container {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  background: white !important;
                  padding: 0 !important;
                }
                .print-page {
                  page-break-after: always;
                  page-break-inside: avoid;
                  margin: 0 !important;
                  padding: 0 !important;
                  background: white !important;
                  display: block !important;
                  width: 100% !important;
                  height: auto !important;
                }
                .print-page:last-child {
                  page-break-after: auto;
                }
                .no-print {
                  display: none !important;
                }
                /* Hide any fixed positioned elements that might show download buttons */
                div[style*="position: fixed"] {
                  display: none !important;
                }
                /* Hide any overlay buttons */
                button {
                  display: none !important;
                }
                /* Ensure clean print output */
                * {
                  -webkit-print-color-adjust: exact !important;
                  color-adjust: exact !important;
                }
                /* Remove any extra spacing or margins that cause empty pages */
                .print-page > div {
                  margin: 0 !important;
                  padding: 0 !important;
                  background: white !important;
                  box-shadow: none !important;
                  border: none !important;
                }
                /* Ensure PDF components fill the page properly */
                .print-page > div > div {
                  margin: 0 auto !important;
                  box-shadow: none !important;
                  background: white !important;
                  padding: 0 !important;
                }
                /* Remove any container backgrounds and shadows */
                .print-container {
                  background: white !important;
                  padding: 0 !important;
                  margin: 0 !important;
                }
                /* Ensure proper spacing between content */
                .print-page + .print-page {
                  margin-top: 0 !important;
                  padding-top: 0 !important;
                }
              }
              
              @media screen {
                .print-page {
                  margin-bottom: 40px;
                }
                .print-page:last-child {
                  margin-bottom: 0;
                }
              }
            `}</style>
            {bulkPreviewData.map((release, index) => {
              const _data = release.formData;
              const director = directors[0] || {};

              return (
                <div key={index} className="print-page">
                  {_data.approval_type === "Capital" ||
                  (_data.approval_type === "Recurrent" &&
                    release.length === 1) ? (
                    <RealiseCollectionPdfWebView
                      form={_data}
                      selecOffer={formatNumber}
                      today={moment().format("LL")}
                      user={director}
                      title="Signed Approvals"
                    />
                  ) : (
                    <NewRelisePdfWebView
                      selectedData={release.pdfData}
                      selecOffer={formatNumber}
                      today={moment().format("LL")}
                      user={director}
                      title="Signed Approvals"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    // Render with tabs if showHistoryTab is true
    if (showHistoryTab) {
      return (
        <Card style={{ minHeight: "80vh" }}>
          <Nav
            tabs
            style={{
              marginLeft: 15,
              marginTop: 15,
              borderBottom: "2px solid #e0e0e0",
            }}
          >
            <NavItem>
              <NavLink
                active={activeTab === "1"}
                onClick={() => setActiveTab("1")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "1" ? "#fff" : "#666",
                  backgroundColor:
                    activeTab === "1" ? "#51ce5bff" : "transparent",
                  borderRadius: "8px 8px 0 0",
                  fontWeight: activeTab === "1" ? "bold" : "normal",
                  padding: "10px 20px",
                  border:
                    activeTab === "1"
                      ? "2px solid #51cbce"
                      : "2px solid transparent",
                  borderBottom:
                    activeTab === "1" ? "none" : "2px solid transparent",
                  marginBottom: "-2px",
                }}
              >
                Current Releases
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "2"}
                onClick={() => setActiveTab("2")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "2" ? "#fff" : "#666",
                  backgroundColor:
                    activeTab === "2" ? "#51ce5bff" : "transparent",
                  borderRadius: "8px 8px 0 0",
                  fontWeight: activeTab === "2" ? "bold" : "normal",
                  padding: "10px 20px",
                  border:
                    activeTab === "2"
                      ? "2px solid #51cbce"
                      : "2px solid transparent",
                  borderBottom:
                    activeTab === "2" ? "none" : "2px solid transparent",
                  marginBottom: "-2px",
                }}
              >
                Release History
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} style={{ padding: "20px" }}>
            <TabPane tabId="1">{CurrentReleasesContent()}</TabPane>
            <TabPane tabId="2">
              <ReleaseHistoryGenericTab />
            </TabPane>
          </TabContent>
        </Card>
      );
    }

    // Default render without tabs
    return (
      <Card>
        <MDBox>
          <MDTypography variant="h5" color="white">
            {title}
          </MDTypography>
        </MDBox>
        {CurrentReleasesContent()}
      </Card>
    );
  };

  return (
    <>
      {processingPage ? (
        RenderComponent()
      ) : (
        <DashboardLayout>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="success"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h5" color="white" className="text-center">
              {title}
            </MDTypography>
          </MDBox>
          {RenderComponent()}
        </DashboardLayout>
      )}
    </>
  );
}
